import Vue from 'vue'
import { instance, errorService } from '@/services/api'
import { dropdownAPIs, masterAPIs } from '@/services/authConstantsV1'
import _ from 'lodash'
import DynamicTable from '@/components/DynamicComponents/Admin/MasterData/Grid'
import axios from 'axios'
import { calculations, socketEvents } from '@/services/config'
import { showNotification } from '@/services/calculate'

export default {
  components: {
    DynamicTable,
  },
  data: function () {
    return {
      loader: true,
      headStyle: {
        'font-weight': 'bold',
        background: '#333333 !important',
        color: '#ffffff !important',
        padding: '0 10px',
      },
      dropdownData: [],
      groupingList: [],
      loading: false,
      columnDefs: null,
      create: new Vue(),
      bankDetails: null,
      categoryCodeList: [],
      contractList: [],
      loaderTitle: 'Please wait...',
      area: undefined,
      perimeter: undefined,
      conditionFactorList: [],
    }
  },
  mounted() {
    this.$socketHub.$on('message-received', this.messageRecieved)
    this.$root.$on('showDisplayLoader', this.showDisplayLoader)
  },
  beforeDestroy() {
    this.$root.$off('showDisplayLoader', this.showDisplayLoader)
    this.$socketHub.$off('message-received', this.messageRecieved)
  },
  created() {
    this.loadColumns()
    this.getGroupingById()
    this.getDropDownData()
  },
  methods: {
    async getDropDownData() {
      this.dropdownData = []
      Promise.all([this.loadDropdowns()])
        .then(
          axios.spread((...responses) => {
            const result = JSON.stringify(
              _.get(responses[0].data, 'result', []),
            )
            this.dropdownData = JSON.parse(result)
            var dropdownData = JSON.parse(result)
            Object.assign(this.dropdownData, { calculation: calculations })
            dropdownData.condition_factor.map(e => {
              this.conditionFactorList.push(e)
            })
          }),
        )
        .catch(errors => {
          errorService(errors)
        })
    },

    getGroupingById() {
      instance
        .get(masterAPIs.groupingBank.details(this.$route.params.id))
        .then(response => {
          this.bankDetails = _.get(response.data, 'result', null)
          Object.assign(this.bankDetails, {
            interior_Grouping_Id: this.bankDetails.id,
          })
          this.groupingList = _.get(response.data.result, 'takeoffs', [])
          this.area = _.get(response.data, 'result.area', null)
          this.perimeter = _.get(response.data, 'result.perimeter', null)
          Object.assign(this.dropdownData, { calculation: calculations })
          this.loader = false
        })
        .catch(error => {
          this.loader = false
          errorService(error)
        })
    },

    back() {
      this.$router.push('/master/grouping-bank')
    },

    updateTakeOff(takeOff) {
      this.groupingList = [...takeOff]
    },

    loadColumns() {
      this.columnDefs = [
        {
          rowDrag: true,
          headerName: '',
          field: 'display',
          floatingFilter: false,
          width: 3,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
          sortable: false,
          pinned: 'left',
          menuTabs: [],
        },
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: '',
          field: 'isValidTakeoff',
          hide: true,
        },
        {
          headerName: 'Contract',
          field: 'contract',
          cellEditor: 'selectEditor',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: { type: 'dynamicTable', dataType: 'int' },
          width: 100,
          headerTooltip: 'Contract',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
          editable: false,
        },
        {
          headerName: 'Category Code',
          field: 'categoryCode',
          cellStyle: { textAlign: 'left' },
          width: 150,
          cellEditor: 'selectEditor',
          headerClass: 'header-center',
          cellRendererParams: { type: 'dynamicTable', dataType: 'string' },
          headerTooltip: 'Category Code',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
          editable: false,
        },
        {
          headerName: 'Additional Description',
          field: 'additionalDescription',
          headerClass: 'header-center',
          cellStyle: { textAlign: 'center' },
          cellEditor: 'textEditor',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'string',
            placeholder: 'Additional Description',
          },
          width: 150,
          headerTooltip: 'Additional Description',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Takeoff Description',
          field: 'takeoff',
          cellEditor: 'takeoffSelectEditor',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'string',
            name: 'takeoff_Name',
            screen: 'master',
          },
          headerTooltip: 'Takeoff',
          cellRenderer: 'toolTipRenderer',
          width: 400,
        },
        {
          headerName: 'Calculation',
          field: 'calculation',
          cellEditor: 'calculationEditor',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'string',
            name: 'calculation',
            dropdownData: calculations,
          },
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Calculation',
          resizable: true,
          sortable: false,
          floatingFilter: false,
          width: 100,
        },
        {
          headerName: 'Quantity',
          field: 'quantity',
          headerClass: 'header-right',
          cellStyle: { textAlign: 'right' },
          cellEditor: 'inputNumberEditor',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'int',
            placeholder: 'Quantity',
            precision: 0,
            min: 0,
            max: 999999999,
          },
          width: 100,
          headerTooltip: 'Quantity',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Unit',
          field: 'unit',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellEditor: 'selectEditor',
          cellRendererParams: { type: 'dynamicTable', dataType: 'string' },
          width: 100,
          headerTooltip: 'Unit',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
          editable: false,
        },
        {
          headerName: 'Unit Cost',
          field: 'unitCost',
          cellStyle: { textAlign: 'right' },
          headerClass: 'header-right',
          cellEditor: 'inputCellEditor',
          cellRenderer: 'costPriceCellRenderer',
          cellRendererParams: { type: 'dynamicTable', dataType: 'string' },
          width: 120,
          headerTooltip: 'Unit Cost',
          suppressSizeToFit: true,
          editable: false,
        },
        {
          headerName: 'Condition Factor',
          field: 'conditionFactor',
          headerClass: 'header-center',
          cellEditor: 'selectEditor',
          wrapText: false,
          filter: 'customFilter',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'int',
            dropdownName: 'conditionFactor',
            dropdownData: this.conditionFactorList,
            name: 'conditionFactor',
            width: '350px !important',
            editable: true,
          },
          width: 150,
          headerTooltip: 'Condition Factor',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Multiplier',
          field: 'multiplier',
          cellStyle: { textAlign: 'right' },
          headerClass: 'header-right',
          cellEditor: 'inputNumberEditor',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            name: 'multiplier',
            type: 'dynamicTable',
            dataType: 'int',
            precision: 3,
          },
          width: 100,
          headerTooltip: 'Multiplier',
          suppressSizeToFit: true,
        },
        {
          headerName: 'Action',
          field: 'action',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          sortable: false,
          editable: false,
          cellRenderer: 'actionCellRenderer',
          floatingFilter: false,
          width: 60,
          cellRendererParams: {
            type: 'groupingBank',
            url: masterAPIs.groupingBank.takeoff.delete,
          },
          pinned: 'right',
          menuTabs: [],
        },
      ]
    },

    loadDropdowns() {
      const req = {
        construction_quality_factor: 0,
        condition_factor: 0,
      }
      return instance.post(dropdownAPIs.dropdown, req)
    },

    messageRecieved(message) {
      const data = JSON.parse(message.message)
      if (data.EventType === socketEvents.bankAreaUpdated) {
        this.loaderTitle = 'Please wait...'
        this.loader = true
        this.getGroupingById()
      } else if (data.EventType === socketEvents.error) {
        showNotification(
          'error',
          'Socket',
          _.get(data, 'Result.Message', null),
        )
        this.loaderTitle = 'Please wait...'
        this.loader = true
      }
    },

    showDisplayLoader(flag, show) {
      if (flag) {
        this.loaderTitle = 'Please wait while updating area'
        this.loader = show
      }
    },
  },
}
